import axios from '@bigo/axios-common';
import { getToken, generateSeqId } from '@/common/utils';
import { STORAGE_KEY } from '@/constants/storage';
import i18n from '@/i18n';

// 覆盖@bigo/axios-common的transformRequest
axios.defaults.transformRequest = [
  (data, headers) => {
    if (headers['Content-Type'] === 'application/json') {
      data = JSON.stringify({ ...data });
    }

    return data;
  },
];

axios.defaults.timeout = 50000;

axios.interceptors.request.use(
  (config) =>
    getToken().then(
      (token) => {
        const contentType = config.headers['content-type'] || config.headers['Content-Type'];
        if (contentType === 'application/octet-stream') {
          console.log('upload file');
        } else if (contentType === 'application/x-www-form-urlencoded') {
          config.params = { ...(config.params || {}), token };
        } else if ('isC' in config.headers) {
          const deviceId = localStorage.getItem(STORAGE_KEY.DEVICE_ID);
          config.headers['bigo-device-id'] = deviceId;
          config.headers['bigo-appid'] = 60;
          config.headers['X-Client-Lang'] = i18n.global.locale.value;
          config.headers['X-Auth-Token'] = token;
          config.headers.requestid = generateSeqId();
          delete config.headers.isC;
        } else {
          config.headers['X-Auth-Token'] = token;
          config.headers.requestid = generateSeqId();
        }
        return config;
      },
      (error) => Promise.reject(error),
    ),
  (error) => Promise.reject(error),
);

/**
 * 通用 get 方法请求
 * @param {*} url 链接url
 * @param {*} params 请求参数
 */
export const get = (url: string, params = {}): Promise<any> =>
  axios({
    url,
    params: params || {},
    method: 'get',
  });

/**
 * 通用post请求
 * @param {*} url 接口地址
 * @param {*} data 请求参数
 */
export const postJava = (url: string, data = {}, headers = {}): Promise<any> =>
  axios({
    url,
    data: data || {},
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  });

// upload
export const postUpload = (url: string, data = {}, headers = {}): Promise<any> => {
  return axios({
    url,
    data: data || {},
    method: 'post',
    headers: {
      'Content-Type': 'application/octet-stream',
      ...headers,
    },
  });
}

// c++
export const postCpp = (url: string, data = {}, headers = {}): Promise<any> =>
  axios({
    url,
    data: data || {},
    method: 'post',
    headers: {
      isC: true,
      'Content-Type': 'application/json',
      ...headers,
    },
  });

export const getPhp = (url: string, params = {}, headers = {} ): Promise<any> => 
  axios({
    url,
    params: params || {},
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...headers,
    },
  });

export default axios;
